import React from "react";
import Events from "../components/Events";

export default function EventsPage() {
  return <Events />;
}
